import { useState } from 'react';

export default function usePanelState<PanelName extends string>(
  defaultPanel: PanelName
): [PanelName, (panel: PanelName) => void] {
  const [panelState, setPanelState] = useState<PanelName>(defaultPanel);

  const setPanel = (panel: PanelName) => {
    setPanelState((currPanel) => (currPanel === panel ? defaultPanel : panel));
  };

  return [panelState, setPanel];
}
